module.exports = __webpack_public_path__ + "media/src/images/icons/upload-d2704768f782502cc752e47889ba89c6.svg";